// extracted by mini-css-extract-plugin
module.exports = {"select":"TransactionList_select__JWDzJ"};